'use client';

import { CustomErrorView } from 'src/components/custom-error/custom-error-view';
import { SettingsProvider, defaultSettings } from 'src/components/settings';
import { ThemeProvider } from 'src/theme';

// Global error must include html and body tags
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html lang="sv">
            <body>
                <SettingsProvider defaultSettings={defaultSettings}>
                    <ThemeProvider>
                        <CustomErrorView
                            error={error}
                            reset={reset}
                            title="Ett allvarligt fel inträffade"
                            message="Appen kunde inte starta. Felet har loggats — ladda om sidan för att försöka igen."
                        />
                    </ThemeProvider>
                </SettingsProvider>
            </body>
        </html>
    );
}
